/*
 * @Author: kuangxj 
 * @Email: frankxjkuang@gmail.com 
 * @Date: 2018-07-10 10:57:17 
 * @Last Modified by:   kaungxj 
 * @Last Modified time: 2018-07-10 10:57:17 
 * @Description: File desctiption 
 */

import MoorInput from './moor-input';

MoorInput.install = Vue => Vue.component(MoorInput.name, MoorInput);

export default MoorInput;


// WEBPACK FOOTER //
// ./src/packages/input/index.js